module.exports = __webpack_public_path__ + "img/42_28.c8401b2c.png";